import React from "react";
import Typography from "@mui/material/Typography";

export const FooterCustomLine = (props) => {
    let currentYear = new Date().getFullYear();

    return (

        <div className="col-12 bg-blue box">
            <Typography component="div" sx={{ display: { xs: 'none', sm: 'block' } }}>
                <p className="text4 footer2 color-white text-center" >
                    <a href="https://www.facebook.com/CustomLineYacht" target="_blank" rel="noreferrer">Facebook</a>
                    <a href="https://www.pinterest.com/customlineyacht" target="_blank" rel="noreferrer">Pinterest</a>
                    <a href="https://instagram.com/customlineyacht/" target="_blank" rel="noreferrer">Instagram</a>
                    <a href="https://www.youtube.com/channel/UCxgZUhdF_cDrv_erK_LWBeQ" target="_blank" rel="noreferrer">Youtube</a>
                    <a href="https://www.twitter.com/FerrettiGroup" target="_blank" rel="noreferrer">Twitter</a>
                    <a href="http://www.linkedin.com/company/ferretti-group" target="_blank" rel="noreferrer">Linkedin</a>
                </p>
            </Typography>
            <Typography component="div" sx={{ display: { xs: 'block', sm: 'none' } }}>
                <p className="text4 footer2 color-white text-center" sx={{ display: { xs: 'block', sm: 'none' } }}>
                    <a href="https://www.facebook.com/CustomLineYacht" target="_blank" rel="noreferrer">Facebook</a>
                    <a href="https://www.pinterest.com/customlineyacht" target="_blank" rel="noreferrer">Pinterest</a>
                    <a href="https://instagram.com/customlineyacht/" target="_blank" rel="noreferrer">Instagram</a><br /><br />
                    <a href="https://www.youtube.com/channel/UCxgZUhdF_cDrv_erK_LWBeQ" target="_blank" rel="noreferrer">Youtube</a>
                    <a href="https://www.twitter.com/FerrettiGroup" target="_blank" rel="noreferrer">Twitter</a>
                    <a href="http://www.linkedin.com/company/ferretti-group" target="_blank" rel="noreferrer">Linkedin</a>
                </p>
            </Typography>
            <div>
                <p className="text4 footer3 color-white text-center">
                    <a href="https://www.customline-yacht.com" target="_blank" rel="noreferrer">Custom Line</a><br />a <a href="https://www.ferrettigroup.com" target="_blank" rel="noreferrer">Ferretti Group brand</a>< br />
                    COPYRIGHT &copy; {currentYear} Ferretti SPA - Tax code and VAT no. 04485970968 - Registered Office Via Irma Bandiera, 62 - 47841 Cattolica (RN) Italy <br />
                    REA no. RN 296608 - Companies Register no. 04485970968 - Share capital - 338.482.654,00 fully paid-up <br />
                    - Ver. 1.0.5 -
                </p>
            </div>
        </div>
    );
};

export default FooterCustomLine;
